import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AuthenticationStatus = ({ success, message, onReset }) => {
  return (
    <div className="text-center space-y-6">
      <div className="flex justify-center">
        <div className={`w-32 h-32 rounded-full flex items-center justify-center ${
          success 
            ? 'bg-success/10 border-4 border-success' :'bg-error/10 border-4 border-error'
        }`}>
          <Icon 
            name={success ? 'CheckCircle' : 'XCircle'} 
            size={64} 
            className={success ? 'text-success' : 'text-error'}
          />
        </div>
      </div>

      <div>
        <h2 className={`text-2xl font-bold mb-2 ${
          success ? 'text-success' : 'text-error'
        }`}>
          {success ? 'Authentication Successful!' : 'Authentication Failed'}
        </h2>
        <p className="text-muted-foreground">{message}</p>
      </div>

      {success ? (
        <div className="space-y-4">
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={16} />
            <span>Clocked in successfully</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Icon name="Loader2" size={16} className="animate-spin" />
            <span>Redirecting to dashboard...</span>
          </div>
        </div>
      ) : (
        <Button onClick={onReset} size="lg" className="max-w-md mx-auto">
          <Icon name="RotateCcw" size={20} />
          <span>Try Again</span>
        </Button>
      )}

      {success && (
        <div className="p-4 bg-success/5 rounded-lg border border-success/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={18} className="text-success flex-shrink-0 mt-0.5" />
            <div className="text-sm text-muted-foreground text-left">
              <p className="font-medium text-foreground mb-1">What's Next?</p>
              <ul className="space-y-1">
                <li className="flex items-center gap-2">
                  <Icon name="Check" size={14} className="text-success" />
                  <span>Your attendance has been recorded</span>
                </li>
                <li className="flex items-center gap-2">
                  <Icon name="Check" size={14} className="text-success" />
                  <span>Time tracking started automatically</span>
                </li>
                <li className="flex items-center gap-2">
                  <Icon name="Check" size={14} className="text-success" />
                  <span>Access your dashboard for daily tasks</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthenticationStatus;